import { render, staticRenderFns } from "./StockOBVView.vue?vue&type=template&id=1cbe6b0f&scoped=true"
import script from "./StockOBVView.vue?vue&type=script&lang=js"
export * from "./StockOBVView.vue?vue&type=script&lang=js"
import style0 from "./StockOBVView.vue?vue&type=style&index=0&id=1cbe6b0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe6b0f",
  null
  
)

export default component.exports